import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';


class ExternalMediaPlayer extends Component {
  constructor (props) {
    super(props);
    this.handleReady = this.handleReady.bind(this);
  }

  handleReady () {
    const { startTime } = this.props;
    if (startTime) {
      this.playerRef.seekTo(startTime);
    }
  }

  render () {
    const { mediaUrl, load } = this.props;
    return (
      <div className="player-wrap">
        {load ? <ReactPlayer ref={node => this.playerRef = node} url={mediaUrl} width="100%" height="100%" controls onReady={this.handleReady} /> : null }
      </div>
    );
  }
}

ExternalMediaPlayer.propTypes = {
  mediaUrl: PropTypes.string,
  load: PropTypes.bool,
  startTime: PropTypes.number,
};

ExternalMediaPlayer.defaultProps = {
  load: true,
};

export default ExternalMediaPlayer;



// WEBPACK FOOTER //
// ./src/components/ExternalMediaPlayer.js